<template lang="html">

    <section class="banner-marcas row-center">

      <div class="scroll row-center">

      <article class="marca kojak">
        <div class="contenedor-logo row-center">
            <img src="/static/img/kojak-logo.svg" alt="Logo-kojak">
        </div>
        <img src="/static/img/caramelo-kojak.png" alt="caramelo kojak" class="caramelo-envuelto">
        <img src="/static/img/kojak-sin.png" alt="caramelo kojak sin" class="caramelo-sin">
        <img src="/static/img/kojak-sello-autentico.png" class="sello" alt="El autentico">
        <router-link class="enlace-cover" :to="$t('enlaces.producto')+'/kojak'"></router-link>
      </article>


      <article class="marca piruletas">
          <div class="contenedor-logo row-center">
            <img src="/static/img/piruletas-logo.svg" alt="Logo-piruletas">
        </div>
        <img src="/static/img/sello-original.png" alt="La original" class="sello">
        <img src="/static/img/piruleta-1.png" class="piruleta-1" alt="piruleta 1">
        <img src="/static/img/piruleta-2.png" class="piruleta-2" alt="piruleta 2">
        <router-link class="enlace-cover" :to="$t('enlaces.producto')+'/piruletas'"></router-link>
      </article>


      <article class="marca lolipop">
        <div class="contenedor-logo row-center">
            <img src="/static/img/lolipop-logo.svg" alt="Logo-lolipop">
            
        </div>
        <img src="/static/img/sello-masticable.png" alt="Masticable" class="sello">
        <img src="/static/img/lolipop-1.png" class="lolipop-1" alt="lolipop 1">
        <img src="/static/img/lolipop-2.png" class="lolipop-2" alt="lolipop 2">
        <router-link class="enlace-cover" :to="$t('enlaces.producto')+'/lolipop'"></router-link>
      </article>


      <article class="marca fresquito">
        <div class="contenedor-logo row-center">
            <img src="/static/img/freskito-logo.svg" alt="Logo-fresquito">
        </div>
        <img src="/static/img/sello-divertido.svg" alt="Divertido" class="sello">
        <img src="/static/img/fresquito-to-left.png" class="fresquito" alt="fresquito">
        <router-link class="enlace-cover" :to="$t('enlaces.producto')+'/fresquito'"></router-link>
      </article>


      <article class="marca regalices">
        <div class="contenedor-logo row-center">
            <img src="/static/img/regalices-logo.png" alt="Logo-regalices">
        </div>
        
        <img src="/static/img/megatorcidas-producto-1.png" class="producto-1" alt="Megatorcidas 1">
        <img src="/static/img/megatorcidas-producto-2.png" class="producto-2" alt="Megatorcidas 1">
        <router-link class="enlace-cover" :to="$t('enlaces.categoria')+'/regalices'"></router-link>
      </article>

    </div>


    </section>
  
  </template>
  
  <script lang="js">
    export default  {
      name: 'banner-marcas',
      mounted(){

    

      //   $(".marca").hover(

      //       function(){

      //           $(".marca").css({"transform":"translateX(0px)"});
      //           $(this).css('transform','scale(1.1)')

      //           let pos = $(this).index();

      //           $(".marca").each(function(el, key){
      //               if(el < pos){
      //                   $(this).css({"transform":"translateX(-30px)"});
      //               }else if(el > pos){
      //                   $(this).css({"transform":"translateX(30px)"});
      //               }
      //           });



      //       },
      //       function(){
      //           $(".marca").css({"transform":"translateX(0px)"});
      //       }
      //   );

      // }
      }
  
  }
  </script>
  



// WEBPACK FOOTER //
// src/components/parts/banner-marcas-home.vue